import React from "react";
import "./Description.css";
import {useLanguage} from "../context/LanguageContext";
const Description = () => {
    const { language, setLanguage } = useLanguage();

    return (
        <div className="description">
            {language === 'en' ? (<h4 className="head">About</h4>): (<h4 className="head_ar">نبذة عامة</h4>)}

            {language === 'en' ? (<p>Grand Slam Gaming: One subscription, diverse content, ad-free. Seamless entertainment</p>):
                (<p className="p_ar">باشتراك واحد، محتوى ألعاب متنوع، بدون إعلانات لتجربة ترفيهية سلسة</p>)}
        </div>
    );
};

export default Description;
